import { buttonOverrides } from './button';
import { chipOverrides } from './chip';
import { cssBaselineOverrides } from './css-baseline';
import { dividerOverrides } from './divider';
import { drawerOverrides } from './drawer';
import { iconButtonOverrides } from './icon-button';
import { linkOverrides } from './link';
import { listItemButtonOverrides, listOverrides } from './list';
import { modalOverrides } from './modal';
import { sliderOverrides } from './slider';
import { stackOverrides } from './stack';
import { switchOverrides } from './switch';
import { textFieldOverrides } from './text-field';
import { tooltipOverrides } from './tooltip';

export default {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        body3: 'p',
      },
    },
  },
  MuiButton: {
    ...buttonOverrides,
  },
  MuiLink: {
    ...linkOverrides,
  },
  MuiStack: {
    ...stackOverrides,
  },
  MuiIconButton: {
    ...iconButtonOverrides,
  },
  MuiModal: {
    ...modalOverrides,
  },
  MuiChip: {
    ...chipOverrides,
  },
  MuiSwitch: {
    ...switchOverrides,
  },
  MuiList: {
    ...listOverrides,
  },
  MuiListItemButton: {
    ...listItemButtonOverrides,
  },
  MuiSlider: {
    ...sliderOverrides,
  },
  MuiDivider: {
    ...dividerOverrides,
  },
  MuiTextField: {
    ...textFieldOverrides,
  },
  MuiTooltip: {
    ...tooltipOverrides,
  },
  MuiCssBaseline: {
    ...cssBaselineOverrides,
  },
  MuiDrawer: {
    ...drawerOverrides,
  },
};
